import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const OrderList = Loadable(lazy(() => import('pages/order/List')));
const OrderModal = Loadable(lazy(() => import('pages/order/OrderModalOpener')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const OrderRoutes: RouteObject = {
    path: 'order',
    children: [
        {
            path: '',
            element: <OrderList />,
        },
        {
            path: ':id',
            element: <OrderModal />,
        },
    ],
};
export default OrderRoutes;
